module.exports = __webpack_public_path__ + "img/ac1_thumb.c8c63165.jpg";